import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=862afa4a"
import script from "./PositionList.vue?vue&type=script&lang=js"
export * from "./PositionList.vue?vue&type=script&lang=js"
import style0 from "./PositionList.vue?vue&type=style&index=0&id=862afa4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports